
<div class="relative min-h-[80vh] overflow-hidden">

  <!-- Swiper background -->
   <swiper-container
        class="absolute top-0 left-0 w-full h-full z-0 pointer-events-none"
        style="height: 100%; width: 100%; display: block;"
        [autoplay]="{ delay: 6000, disableOnInteraction: false }"
        [virtual]="true"
        [loop]="true"
        >
        @for (i of images; track i) {
            <swiper-slide>
            <img
                [src]="`images/front-pages/landscape/${i}_small.avif`"
                loading="lazy"
                decoding="async"
                class="w-full h-full object-cover object-center">
            </swiper-slide>
        }
    </swiper-container>

  <!-- <swiper-container
    class="absolute top-0 left-0 w-full h-full z-0 pointer-events-none"
    style="height: 100%; width: 100%; display: block;"
    [autoplay]="{ delay: 6000, disableOnInteraction: false }"
    [virtual]="true"
    [loop]="true"
  >
    @for (i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21]; track i) {
        <swiper-slide>
            <img 
                [src]="`images/front-pages/landscape/${i}_small.avif`"
                loading="lazy"
                decoding="async"
                class="w-full h-full object-cover object-center">
        </swiper-slide>
    }
  </swiper-container> -->
    
    <!--  Overlay gradient --> 
    <div class="absolute inset-0 z-10 bg-[linear-gradient(to_right,transparent_75%,rgba(255,255,255,0.7)_90%,#ffffff_100%)] dark:bg-[linear-gradient(to_right,transparent_75%,rgba(0,0,0,0.7)_90%,#000000_100%)]"> 

    </div> <!--contenu --> 
    <div class="relative z-20 pt-[150px] mb-[20vh]"> 
        <div class="container 2xl:max-w-[1320px] mx-auto px-[12px] relative z-[1]"> 
            <div class="grid lg:grid-cols-2 gap-10 items-center"> 
                <div class="text-left mx-auto xl:max-w-[935px] mb-[30px] md:mb-[45px] lg:mb-[60px]"> 
                    <h1 class=" !text-3xl md:!text-5xl lg:!text-[50px] xl:!text-[60px] !mb-[13px] md:!mb-[22px] lg:!mb-[25px] xl:!mb-[30px] -tracking-[.5px] md:-tracking-[1px] xl:-tracking-[1.5px] !leading-[1.2] !text-white drop-shadow-[0_2px_6px_rgba(0,0,0,0.6)]"> 
                        {{ 'i18n.app.features.pages.front-pages.common.fp-banner.h1_01' | translate }} 
                    </h1> 
                    <p class="mx-auto text-gray-40 !leading-[1.6] md:text-[15px] lg:text-md xl:text-lg md:max-w-[600px] lg:max-w-[650px] xl:max-w-[740px] xl:tracking-[.2px] drop-shadow-[0_2px_6px_rgba(0,0,0,0.6)]"> 
                        {{ 'i18n.app.features.pages.front-pages.common.fp-banner.p_01' | translate }} 
                    </p> 
                </div> 
                <app-fp-order-panel></app-fp-order-panel> 
            </div> 

        </div> 
    </div> 
</div>


